export { Ctooltip, CtooltipPlacement } from './Ctooltip';
export type { CtooltipProps } from './Ctooltip';
